import React, { useState } from "react";
import { PayPalButton } from "react-paypal-button-v2";
import { POST_CREATE_PAYPAL_PAYMENT, POST_AUTHORIZE_PAYPAL_PAYMENT } from "../../../graphql/queries";
import Loader from "../../common/loader";
import { useMutation } from "@apollo/client";

const PayPal = ({ config, document, addNotification, onSubmit }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isPaypalLoading, setIsPaypalLoading] = useState(true);
  const [createPaypalPayment] = useMutation(POST_CREATE_PAYPAL_PAYMENT);

  const [authorizePaypalPayment] = useMutation(POST_AUTHORIZE_PAYPAL_PAYMENT);

  const authorizePaypal = async ({ orderID }) => {
    if (!isSubmitting) {
      setIsSubmitting(true);
      try {
        const { data } = await authorizePaypalPayment({ variables: { paypalOrderId: orderID } });
        await onSubmit({ type: "paypal", authorizationId: data.paypalAuthorizePayment.authorizationId });
      } catch (e) {
        addNotification({ ok: 0, message: e.data });
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  return (
    <>
      <PayPalButton
        amount={document.totals.grand}
        shippingPreference="NO_SHIPPING"
        createOrder={async () => {
          const { data } = await createPaypalPayment({ variables: { documentId: document.id } });
          return data.paypalCreateOrder.orderId;
        }}
        onApprove={authorizePaypal}
        onButtonReady={() => setIsPaypalLoading(false)}
        onError={(err) => addNotification({ ok: 0, message: err.toString() })}
        catchError={(err) => addNotification({ ok: 0, message: err.toString() })}
        options={{
          intent: "authorize",
          currency: config.getProperty("information", "currency").toUpperCase(),
          clientId:
            process.env.REACT_APP_BUILD_ENV === "production" ? config.getProperty("paypal", "clientID") : process.env.REACT_APP_PAYPAL_CLIENT_ID
        }}
        style={{
          layout: "horizontal",
          color: "black",
          shape: "rect",
          label: "paypal",
          tagline: false
        }}
      />
      {isPaypalLoading ? <Loader withMargins /> : null}
    </>
  );
};

export default PayPal;
